import { marketplaceData } from 'helpers'



const getMarketplaceTool = (state, areaName = 'mc') => {
  const { marketplace: { layersNavigation: { category, tool, tools, area } } } = state
  const { areas, tools: marketplaceTools } = marketplaceData
  
  const isZv        = window && window.location && window.location.host === 'smart-fe26.ru'
  const areaId      = areas[areaName]
  const isArea      = !areaName || area === areaId // isMC

  const activeTool  = category === 'sport' && tools.find(({ areas }) => areas.find(({ id }) => id === tool)) || {}

  if ((category !== 'edu' && category !== 'rpc') && !activeTool.id) {
    return ''
  }
  // TODO move this logic to backend
  const isSauna     = activeTool.id === marketplaceTools.sauna && isArea
  // const isBanya     = activeTool.id === marketplaceTools.banya && isArea
  const isPool      = activeTool.id === marketplaceTools.pool && isArea
  const isGym       = activeTool.id === marketplaceTools.gym && isArea
  const isTennis    = activeTool.id === marketplaceTools.tennis && isArea
  const isRink      = activeTool.id === marketplaceTools.rink && isArea
  const isTramp     = activeTool.id === marketplaceTools.tramp && isArea
  const isMfc       = activeTool.id === marketplaceTools.mfc && isArea

  const isSchool    = Boolean((category === 'edu' || category === 'rpc') && tool)

  if (isSchool) {
    return 'school'
  }

  if (isZv && tool) {
    return 'tennis'
  }

  if (isSauna) {
    return 'sauna'
  }
  //
  // if (isBanya) {
  //   return 'banya'
  // }

  if (isPool) {
    return 'pool'
  }

  if (isGym) {
    return 'gym'
  }

  if (isTennis) {
    return 'tennis'
  }

  if (isRink) {
    return 'rink'
  }

  if (isTramp) {
    return 'tramp'
  }

  if (isMfc) {
    return 'mfc'
  }

  return ''
}


export default getMarketplaceTool
